import { api } from "../api.js";
import { el } from "./dom.js";

export function leaderboardPanel(currentUsername?: string): HTMLElement {
  const tbody = el("tbody");

  tbody.replaceChildren(
    el("tr", {}, el("td", { colspan: 5, class: "lcard-empty" }, "Loading...")),
  );

  async function load(): Promise<void> {
    try {
      const data = await api.leaderboard(200);
      // Render the full board. Long legacy usernames are truncated by the
      // fixed table layout (ellipsis on .lb-name), so they no longer need
      // to be filtered out — doing so was silently hiding real players.
      const rows = data.rows;
      if (rows.length === 0) {
        tbody.replaceChildren(
          el("tr", {}, el("td", { colspan: 5, class: "lcard-empty" }, "No games played yet. Be the first.")),
        );
        return;
      }
      tbody.replaceChildren(
        ...rows.map((r) => {
          const isMe = currentUsername && r.username.toLowerCase() === currentUsername.toLowerCase();
          return el(
            "tr",
            { class: isMe ? "is-me" : "" },
            el("td", { class: "lb-rank" }, String(r.rank).padStart(2, "0")),
            el("td", { class: "lb-name" }, r.username),
            el("td", { class: "lb-num" }, String(r.kills)),
            el("td", { class: "lb-num" }, String(r.deaths)),
            el("td", { class: "lb-num lb-kd" }, r.kd.toFixed(2)),
          );
        }),
      );
    } catch {
      tbody.replaceChildren(
        el("tr", {}, el("td", { colspan: 5, class: "lcard-empty error" }, "Failed to load leaderboard.")),
      );
    }
  }

  void load();
  const refreshInterval = window.setInterval(() => void load(), 30_000);

  const wrap = el(
    "section",
    { class: "lcard lcard-leader" },
    el(
      "header",
      { class: "lcard-head" },
      el("span", { class: "lcard-title" }, "LEADERBOARD"),
    ),
    el(
      "div",
      { class: "lcard-body" },
      el(
        "table",
        { class: "lb-table" },
        el(
          "thead",
          {},
          el(
            "tr",
            {},
            el("th", { class: "lb-rank" }, "#"),
            el("th", { class: "lb-name" }, "PLAYER"),
            el("th", { class: "lb-num" }, "K"),
            el("th", { class: "lb-num" }, "D"),
            el("th", { class: "lb-num" }, "K/D"),
          ),
        ),
        tbody,
      ),
    ),
  );

  new MutationObserver((muts) => {
    for (const m of muts) {
      for (const r of Array.from(m.removedNodes)) {
        if (r === wrap || (r as HTMLElement).contains?.(wrap)) {
          clearInterval(refreshInterval);
        }
      }
    }
  }).observe(document.body, { childList: true, subtree: true });

  return wrap;
}
